import {
  PatrimonyAction,
  PatrimonyActionTypes,
  PatrimonyState,
} from './patrimonyTypes'

const initialState: PatrimonyState = {
  isEditing: false,
  patrimony: [],
  loadingPatrimony: true,
  savingPatrimony: false,
  selectedIndex: null,
  removingPatrimony: false,
  filterPatrimony: '',
  filters: {
    dateFrom: '',
    dateTo: '',
  },
}

export default function patrimonyReducer(
  state = initialState,
  action: PatrimonyAction
) {
  switch (action.type) {
    // filter or search
    case PatrimonyActionTypes.FILTER_PATRIMONY:
      return {
        ...state,
        filterPatrimony: action.filterPatrimony,
      }

    // get item
    case PatrimonyActionTypes.GET_PATRIMONY_START:
      return {
        ...state,
        loadingPatrimony: true,
      }
    case PatrimonyActionTypes.GET_PATRIMONY_SUCCESS:
      if (!action.patrimony) {
        throw new Error()
      }
      return {
        ...state,
        loadingPatrimony: false,
        patrimony: action.patrimony,
      }
    case PatrimonyActionTypes.GET_PATRIMONY_ERROR:
      return {
        ...state,
        loadingPatrimony: false,
      }

    // Edit item
    case PatrimonyActionTypes.EDITING_START:
      return {
        ...state,
        isEditing: true,
        selectedIndex: action.index ?? null,
      }

    case PatrimonyActionTypes.EDITING_CANCEL:
      return {
        ...state,
        isEditing: false,
      }

    // saving

    case PatrimonyActionTypes.SAVE_PATRIMONY_START:
      return {
        ...state,
        savingPatrimony: true,
      }

    case PatrimonyActionTypes.SAVE_PATRIMONY_SUCCESS:
      return {
        ...state,
        savingPatrimony: false,
        selectedIndex: null,
        filterPatrimony: '',
      }

    case PatrimonyActionTypes.SAVE_PATRIMONY_ERROR:
      return {
        ...state,
        savingPatrimony: false,
      }

    // remove item

    case PatrimonyActionTypes.REMOVE_PATRIMONY_START:
      return {
        ...state,
        removingPatrimony: true,
      }

    case PatrimonyActionTypes.REMOVE_PATRIMONY_SUCCESS:
      return {
        ...state,
        removingPatrimony: false,
        selectedIndex: null,
        isEditing: false,
        filterPatrimony: '',
      }

    case PatrimonyActionTypes.REMOVE_PATRIMONY_ERROR:
      return {
        ...state,
        removingPatrimony: false,
      }

    case PatrimonyActionTypes.SET_FILTERS:
      if (!action.filters) {
        throw new Error()
      }
      return {
        ...state,
        filters: action.filters,
      }

    // clear item
    case PatrimonyActionTypes.CLEAR_PATRIMONY:
      return initialState

    default:
      return state
  }
}
